import { defineStore } from 'pinia';
import priceproducts from "../service/priceproducts"
import products from '../service/products';

const priceStore = defineStore('priceproduct', {
  state: () => {
    return {
      prices: [],
      selectedPrice: {}
    }
  },
  actions: {
    async getAllPrices() {
      try {
        const res = await priceproducts.getAllPrices();
        this.prices = res.result;
      } catch (e) {
        console.log(e);
      }
    },
    async getPricesById(id) {
      try {
        const res = await priceproducts.getPriceById(id);
        this.selectedPrice = res.result;
      } catch (e) {
        console.log(e);
      }
    },
    async createPrice(price) {
      try {
        const res = await priceproducts.createPrice(price);
        this.prices = [...this.prices, res.result];
      } catch (e) {
        console.log(e);
      }
    },
    async removePrice(id) {
      try {
        await priceproducts.removePrice(id);
        this.prices = this.prices.filter(p => p._id != id);
      } catch (e) {
        console.log(e);
      }
    },
    async updatePrice(id, price) {
      try {
        await priceproducts.updatePrice(id, price);
      } catch (e) {
        console.log(e);
      }
    }
  }
})

export default priceStore;